import { Component, OnInit, ViewChild, ChangeDetectorRef, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FeesEstimationService } from '../fees-estimation-request/fees-estimation.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AgentService } from '../shared/services/agent.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { Languages, FormMode, ServiceStatus, Service } from 'src/app/shared/models/enums.model';
import { TransitRequestDto } from './transit-request.model';
import { first } from 'rxjs/operators';
import { TransitService } from './transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { FeesEstimationDetailsComponent } from '../fees-estimation-details/fees-estimation-details.component';
import { FeesEstimate } from '../fees-estimation-request/fees-estimate.model';
import { TransitAdminDto } from 'src/app/admin/e-services/e-booking/shared/models/transit-admin.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AppConfig } from 'src/app/shared/services/app.config';


@Component({
  selector: 'app-transit-request',
  templateUrl: './transit-request.component.html',
  styleUrls: ['./transit-request.component.css']
})
export class TransitRequestComponent implements OnInit {
  @ViewChild('TransitTabs',{static: false}) TransitTabs: TabsetComponent;
  feesEstimationUpdated: FeesEstimate = new FeesEstimate();
  transitForm: FormGroup;
  formSubmitted: boolean = false;
  securityLevels: GenericLookup[] = [];
  displayedLang: Languages;

  @ViewChild('transitRequest',{static: false}) transitRequestEle: ElementRef;
  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  transitRequest: TransitRequestDto = new TransitRequestDto();
  showRequest: boolean = false;
  loggedInUser: User = new User();
  public Languages: any = Languages;
  nationalities: GenericLookup[] = [];
  feesRequestId: string;
  transitRequestId: string = '';
  responseObj: ResponseObject = new ResponseObject();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  @ViewChild('feesRequest',{static: false}) feesRequest: FeesEstimationDetailsComponent;
  cancelTransitDto: TransitAdminDto = new TransitAdminDto();
  @Output() FeesEstimateObjValue = new EventEmitter<FeesEstimate>();
  showCancel: boolean = false;
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  public ServiceStatus: any = ServiceStatus;
  @Input() IsAdminMode: boolean = false;
  isTabOneValid: boolean = false;

  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  errorIMO: any = { isError: false, errorMessage: '' };
  isErrorMessage: boolean = false;
  FeesRequestNumber: string;
  todayDate: Date = new Date(new Date().setDate(new Date().getDate() ));
  showHeader: boolean = false;
  showSubmit: boolean = false;
  lockTaskErrorMessage: boolean = false;

  bsValue: Date = new Date(2017, 7);
  lockTaskDoneErrorMessage: boolean= false;
  constructor(
    private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private transitSrv: TransitService,
    private alertService: AlertService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private agentSrv: AgentService, private baseRequestService: BaseRequestService, private router: Router,
    private feesSrv: FeesEstimationService) {
    this.loggedInUser = this.authSrevice.currentUserValue;
    this.displayedLang = this.globalSrv.getLanguage();
    //// will be as input
    //  this.feesRequestId = '52912588-F7AC-4CF7-8B07-6D1DDCBB3D04';
    // //this.transitRequestId = '852372C7-50A3-49C7-9FCF-9E97FF3F1A71';
    if (localStorage.getItem('FeesRequestId') != undefined && this.formMode == FormMode.Add) {
      this.feesRequestId = localStorage.getItem('FeesRequestId');
      this.CheckCanApplyTransit();
      localStorage.removeItem('FeesRequestId');
      this.getFeesbaseRequest(this.feesRequestId);
    }
    else if (localStorage.getItem('TransitRequestId') != undefined) {
      this.transitRequestId = localStorage.getItem('TransitRequestId');
      localStorage.removeItem('TransitRequestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.transitRequestId = history.state.data.requestId;

    }
    else {
      this.router.navigate(['/unAuhtorized']);
    }

  }

  ngOnInit() {
    this.buildForm();

    this.getLookups();
    if (this.transitRequestId) {
      this.getTransitRequest();
      if (!this.loggedInUser.IsAdmin) {
        this.showHeader = true;
      }
      else {
        this.showHeader = false;
      }
    }
  }

  selectTab(tabId: number) {
    this.TransitTabs.tabs[tabId].disabled = false;
    this.TransitTabs.tabs[tabId].active = true;
  }
  receiveTabOneValidity($event) {

    this.isTabOneValid = $event
  }
  buildForm() {
    this.transitForm = this.formBuilder.group({
      D_FWD: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      D_AFT: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      AirDraught: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      Anchors: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      ShipsCranes: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      Class: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      BuildingDate: ['', [Validators.required]],
      LastName: ['', [CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      LastFlagId: [''],
      Extensions: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      FloatingUnits: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      IMONO: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern("^[0-9]{7,7}$")]],
      RegisteryCertificateDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      SecurityLevelId: ['', Validators.required],
      PropellerType: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      ExtraFee: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern(this.numberRegex), Validators.maxLength(150)]],
      MaxManouveringSpeed: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      //AntipollutionService: [false, [Validators.requiredTrue]],
    });

  }


  getLookups() {
    this.lookupService.GetSecurityLevel()
      .subscribe((data: ResponseObject) => {
        this.securityLevels = data.Data.filter(p => p.IsDeleted == false) as GenericLookup[];
      });
    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data.filter(p => p.IsDeleted == false) as GenericLookup[];
    });

  }
  getLookupsWithDeleted() {
    this.lookupService.GetSecurityLevel()
      .subscribe((data: ResponseObject) => {
        this.securityLevels = data.Data as GenericLookup[];
      });
    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data as GenericLookup[];
    });

  }
  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    this.FeesEstimateObjValue.emit(this.FeesEstimateObj);
  }

  get f() {
    return this.transitForm.controls;
  }

  onSubmit() {

    // nashwa validation focus
    // const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
    // if (invalidElements.length > 0) {
    //   invalidElements[0].focus();

    // }

    const invalidElements = this.transitRequestEle.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      if (!this.isTabOneValid) {
        invalidElements[0].focus();
        this.navigateToTab(0);
        //return;
      }
      else {
        invalidElements[0].focus();
        this.navigateToTab(1);
        // return;
      }

    }
    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.transitForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.feesRequest.feesDetailsForm.controls.ETA.value) {
      var selectedDate = this.feesRequest.feesDetailsForm.controls.ETA.value.toLocaleString('en-US',{year: "numeric",month: "numeric",day: "numeric"});
      var selectedTime = this.feesRequest.feesDetailsForm.controls.ETATime.value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric',second: 'numeric', hour12: true })
      var fullDate = selectedDate + ", " + selectedTime;
      this.feesRequest.feesDetailsForm.controls.ETA.setValue(fullDate);
    }

    //************Transit Date *************/
    let dateNow = new Date();
    var selectedTransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value.toLocaleString('en-US');
    this.feesRequest.feesDetailsForm.controls.TransitDate.setValue(selectedTransitDate);

    //***************Registry Certificate****** */
    var selectedRegisteryDate = this.transitForm.controls.RegisteryCertificateDate.value.toLocaleString('en-US');
    this.transitForm.controls.RegisteryCertificateDate.setValue(selectedRegisteryDate);

    //**********Building Date******** */
    var selectedBuildingDate = this.transitForm.controls.BuildingDate.value.toLocaleString('en-US');
    this.transitForm.controls.BuildingDate.setValue(selectedBuildingDate);


    this.transitRequest = this.transitForm.value;
    this.transitRequest.RequestorId = this.loggedInUser.UserId
    this.transitRequest.FeesRequestId = this.feesRequestId;
    this.transitRequest.ActualTransitDate =  this.feesRequest.feesDetailsForm.controls.TransitDate.value;
    this.transitRequest.ArrivalDateTime = this.feesRequest.feesDetailsForm.controls.ETA.value;

    this.transitSrv.add(this.transitRequest).pipe(first())
      .subscribe(
        (data: ResponseObject) => {

          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = false;
            this.transitForm.reset();

          }
          else if (data.ErrorMessages.find(e => e == "AlreadyHaveTransit") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //  this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

          }

        });



  }

  // updateTransitDates(){
  //   this.feesSrv.UpdateTransitDate(this.feesEstimationUpdated).pipe(first())
  //   .subscribe(
  //     (data: ResponseObject) => {
  //
  //       if (data.Success) {
  //         this.globalSrv.isLoaderEnabled = false;
  //         this.showRequest = true;

  //       }
  //       else {
  //         this.globalSrv.isLoaderEnabled = false;
  //         this.showRequest = false;
  //         this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

  //       }

  //     });
  // }

  public getbaseRequest() {
    this.baseRequestService.getBaseRequest(this.transitRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.feesRequestId = this.baseRequestDTO.ParentRequestId;
        this.getFeesbaseRequest(this.baseRequestDTO.ParentRequestId);
      });
  }
  public getFeesbaseRequest(feesRequestId) {
    this.baseRequestService.getBaseRequest(feesRequestId).subscribe(
      d => {
        this.FeesRequestNumber = d.Data.RequestNumber;
      });
  }
  public getTransitRequest() {
    this.transitSrv.get(this.transitRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.getLookupsWithDeleted();
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitRequest.IsCancelled = resObj.Data['IsCancelled'];
          this.transitForm.disable();
          this.formMode = FormMode.Readonly;
          this.transitForm.patchValue(resObj.Data);
          //-------Antipollution Service-------
          /*this.transitForm.patchValue({
            AntipollutionService: true,
          });*/
          //--------------------------------------
          this.getbaseRequest();
        }
      });
  }

  cancelTransit() {
    this.globalSrv.isLoaderEnabled = true;
    this.cancelTransitDto.RequestId = this.transitRequestId;
    this.cancelTransitDto.AdminEmail = this.loggedInUser.UserName;
    this.transitSrv.CancelTransit(this.cancelTransitDto).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.showCancel = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskDoneErrorMessage = true;
            this.showRequest = true;
            this.showCancel = false;
            this.globalSrv.isLoaderEnabled = false;
            this.isErrorMessage = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.showCancel = false;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
          }
        });
  }

  CheckCanApplyTransit() {
    this.agentSrv.CanApplyTransitRequest(this.loggedInUser.UserName, this.feesRequestId).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (!data.Success) {
            this.router.navigate(['/unAuhtorized']);
          }
        });
  }

  getFeesByTransitId() {
    // let requestId = this.feesRequestId;
    // const navigationExtras: NavigationExtras = { state: { data: { requestId } } };
    // this.router.navigate(['/feesEstimation'], navigationExtras);

    localStorage.setItem('FeesEstRequestId', this.feesRequestId);
    window.open('#/feesEstimation', '_blank');
  }

  navigateToTab(tabId: number) {
    this.TransitTabs.tabs[tabId].disabled = false;
    this.TransitTabs.tabs[tabId].active = true;
  }
  get validateSubmitButton() {
    if (this.isTabOneValid) {
      if (this.TransitTabs.tabs[1].disabled == false &&
        this.TransitTabs.tabs[1].active == true) {
        this.showSubmit = true;
      }

    }
    return this.showSubmit;
  }

  goToAntipollutionPage(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.AntipollutionFormAR, '_blank');
    else
     window.open(AppConfig.settings.apiServer.AntipollutionFormEN, '_blank');
  }
  goToAntipollutionCircular(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.AntipollutionCircularAR, '_blank');
    else
     window.open(AppConfig.settings.apiServer.AntipollutionCircularEN, '_blank');
  }
}
